import { z } from "zod";
import {
  taskSignatureMetaSchema,
  taskSignatureWithEmailSchema,
} from "../../shared/signature.js";

// Le PDF du PV rend un certificat de signature à partir de ces traces ; il les
// lit sous le namespace `PvReception`, d'où ce ré-export.
export {
  SIGNATURE_CHANNELS,
  taskSignatureProofSchema,
} from "../../shared/signature.js";
export type {
  SignatureChannel,
  TaskSignatureProof,
} from "../../shared/signature.js";

/**
 * Même shape que la VT (packages/contracts/src/tasks/payloads/vt/sections/signatures.ts) :
 * le meta de signature est partagé entre types de tâches (voir shared/signature.ts).
 * Deux signataires pour le PV de réception : le chef d'équipe et le client.
 */
export const pvReceptionSignatureTeamLeadSchema = taskSignatureMetaSchema;
export type PvReceptionSignatureTeamLead = z.infer<
  typeof pvReceptionSignatureTeamLeadSchema
>;

export const pvReceptionSignatureClientSchema = taskSignatureWithEmailSchema;
export type PvReceptionSignatureClient = z.infer<
  typeof pvReceptionSignatureClientSchema
>;

export const pvReceptionSignaturesSchema = z
  .object({
    teamLead: pvReceptionSignatureTeamLeadSchema.optional(),
    client: pvReceptionSignatureClientSchema.optional(),
  })
  .partial();

export type PvReceptionSignatures = z.infer<
  typeof pvReceptionSignaturesSchema
>;
